<template>
<div class="chat-bubble-container">
    <transition name="fade-scale">
        <!-- Chat Window for Logged In Users -->
        <section v-if="isOpen && hasChatProfile" class="section-6"  style="z-index: 9999999;">
            <div class="chat-box-div">
                <div class="abubody" v-if="!showFeedbackOverlay">
                    <!-- Header -->
                    <div class="box-top-div">
                        <div class="chat-top-div"><img src="@/assets/images/PriMeds_LogoNEW_White.png" loading="lazy" sizes="56.015625px" srcset="@/assets/images/PriMeds_LogoNEW_White.png 500w, @/assets/images/PriMeds_LogoNEW_White.png 800w, @/assets/images/PriMeds_LogoNEW_White.png 1000w" alt="" class="image-406">
                        <a href="#" @click.prevent="handleCloseChat" class="link-block-56 w-inline-block"><img src="@/assets/images/icon_Close.svg" loading="lazy" alt="" class="image-407"></a>
                    </div>
                        <!-- Chat Messages -->
                        <div class="chat-body-div">
                            <div class="chat-reco-div" ref="chatContainer" @scroll="handleScroll">
                                <!-- Loading Indicator -->
                                <div v-if="isLoadingHistory" class="loading-history">
                                    <div class="loading-spinner"></div>
                                    <span class="loading-text">Loading messages...</span>
                                </div>
                                <div class="chat-div">
                                    <div class="dialogue-div" v-for="(message, index) in messages" :key="`chat-message-${index}`">
                                        <!-- User Message -->
                                        <div class="user-div" v-if="message.role === 'user'">
                                            <div class="speech">
                                                <div class="text-block-806" v-html="message.content"></div>

                                                <!-- User Message Attachments (temporarily disabled)
                                                <div v-if="message.attachments && message.attachments.length > 0" class="message-attachments">
                                                    <div v-for="attachment in message.attachments" :key="attachment.id" class="message-attachment">
                                                        <div v-if="attachment.contentType.startsWith('image/') && attachment.content" class="attachment-image-wrapper">
                                                            <div class="attachment-image">
                                                                <img :src="`data:${attachment.contentType};base64,${attachment.content}`" :alt="attachment.filename" />
                                                            </div>
                                                            <button @click="downloadAttachment(attachment)" class="image-download-btn" title="Download image">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                                    <polyline points="7 10 12 15 17 10"/>
                                                                    <line x1="12" y1="15" x2="12" y2="3"/>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        <div v-else class="attachment-file-info clickable" @click="downloadAttachment(attachment)" title="Click to download">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                                                <polyline points="14 2 14 8 20 8"/>
                                                            </svg>
                                                            <span class="attachment-file-name">{{ attachment.filename }}</span>
                                                            <span class="attachment-file-size">({{ Math.round(attachment.size / 1024) }}KB)</span>
                                                            <svg class="download-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                                <polyline points="7 10 12 15 17 10"/>
                                                                <line x1="12" y1="15" x2="12" y2="3"/>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div> -->

                                                <small v-if="message.timestamp" class="message-timestamp">
                                                    {{ formatTimestamp(message.timestamp) }}
                                                </small>
                                            </div>
                                        </div>
                                        <!-- Assistant Message -->
                                        <div class="platform-div" v-else>
                                            <div class="div-block-1757"></div>
                                            <div class="response-div">
                                                <p class="paragraph-132" v-html="message.content"></p>

                                                <!-- Assistant Message Attachments (temporarily disabled)
                                                <div v-if="message.attachments && message.attachments.length > 0" class="message-attachments">
                                                    <div v-for="attachment in message.attachments" :key="attachment.id" class="message-attachment">
                                                        <div v-if="attachment.contentType.startsWith('image/') && attachment.content" class="attachment-image-wrapper">
                                                            <div class="attachment-image">
                                                                <img :src="`data:${attachment.contentType};base64,${attachment.content}`" :alt="attachment.filename" />
                                                            </div>
                                                            <button @click="downloadAttachment(attachment)" class="image-download-btn" title="Download image">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                                    <polyline points="7 10 12 15 17 10"/>
                                                                    <line x1="12" y1="15" x2="12" y2="3"/>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        <div v-else class="attachment-file-info assistant-attachment clickable" @click="downloadAttachment(attachment)" title="Click to download">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                                                <polyline points="14 2 14 8 20 8"/>
                                                            </svg>
                                                            <span class="attachment-file-name">{{ attachment.filename }}</span>
                                                            <span class="attachment-file-size">({{ Math.round(attachment.size / 1024) }}KB)</span>
                                                            <svg class="download-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                                <polyline points="7 10 12 15 17 10"/>
                                                                <line x1="12" y1="15" x2="12" y2="3"/>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div> -->

                                                <small v-if="message.timestamp" class="message-timestamp">
                                                    {{ formatTimestamp(message.timestamp) }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Input Area -->
                    <div class="box-bottom-div">
                        <div class="chat-area-div">
                            <!-- Attachments Preview -->
                            <div v-if="attachments.length > 0" class="attachments-preview">
                                <div v-for="attachment in attachments" :key="attachment.id" class="attachment-preview-item">
                                    <div class="attachment-icon">
                                        <svg v-if="attachment.contentType.startsWith('image/')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                            <circle cx="8.5" cy="8.5" r="1.5"/>
                                            <polyline points="21 15 16 10 5 21"/>
                                        </svg>
                                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                            <polyline points="14 2 14 8 20 8"/>
                                        </svg>
                                    </div>
                                    <span class="attachment-filename">{{ attachment.filename }}</span>
                                    <span class="attachment-size">({{ Math.round(attachment.size / 1024) }}KB)</span>
                                    <button type="button" @click="handleRemoveAttachment(attachment.id)" class="attachment-remove">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <circle cx="12" cy="12" r="10"/>
                                            <line x1="15" y1="9" x2="9" y2="15"/>
                                            <line x1="9" y1="9" x2="15" y2="15"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div class="form-block-2 w-form">
                                <form class="form-10" @submit.prevent="sendMessage">
                                    <div class="attachment-button" @click="$refs.fileInput.click()" title="Attach files">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <line x1="12" y1="5" x2="12" y2="19"/>
                                            <line x1="5" y1="12" x2="19" y2="12"/>
                                        </svg>
                                    </div>
                                    <textarea
                                        ref="messageInput"
                                        class="text-field-53 w-input"
                                        maxlength="256"
                                        name="message"
                                        rows="1"
                                        placeholder="Type your message..."
                                        v-model="currentMessage"
                                        @keypress.enter.exact.prevent="sendMessage"
                                        @input="autoExpand"
                                        @focus="scrollToBottom"
                                    ></textarea>
                                    <input
                                        type="file"
                                        ref="fileInput"
                                        @change="handleFileChange"
                                        class="file-input-hidden"
                                        multiple
                                        accept="image/*,application/pdf,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    />
                                    <div class="div-block-1754" @click="sendMessage" :class="{ 'disabled': !canSendMessage }">
                                        <img src="@/assets/images/Image_from_iOS.jpg" loading="lazy" alt="Send" class="image-413">
                                    </div>
                                </form>
                            </div>
                            <div class="chtnote">This is not medical advice. Review our terms for more info.</div>
                        </div>
                    </div>
                </div>

                <!-- Feedback Form View -->
                <div class="feedback-container" v-if="showFeedbackOverlay">
                    <div class="feedback-content">
                        <div class="feedback-header">
                            <h3 class="feedback-title">Overall, how would you rate your chat experience?</h3>
                        </div>

                        <!-- Rating Section -->
                        <div class="rating-section">
                            <button
                                v-for="rating in [1, 2, 3, 4]"
                                :key="rating"
                                class="rating-btn"
                                :class="{ 'active': feedbackForm.rating === rating }"
                                @click="feedbackForm.rating = rating"
                            >
                                <img
                                    :src="getRatingIcon(rating, feedbackForm.rating === rating)"
                                    :alt="`Rating ${rating}`"
                                    class="rating-icon"
                                />
                            </button>
                        </div>

                        <!-- Issues Section - Only show if rating is 1-4 -->
                        <div class="feedback-section" v-if="shouldShowIssuesSection">
                            <h4 class="section-title">What went wrong?</h4>
                            <div class="options-grid">
                                <button
                                    v-for="issue in issueOptions"
                                    :key="issue"
                                    class="option-btn"
                                    :class="{ 'active': feedbackForm.issues.includes(issue) }"
                                    @click="toggleIssue(issue)"
                                >
                                    {{ issue }}
                                </button>
                            </div>
                        </div>

                        <!-- Resolution Section -->
                        <div class="feedback-section">
                            <h4 class="section-title">Did we resolve your issue?</h4>
                            <div class="yes-no-buttons">
                                <button
                                    class="yn-btn"
                                    :class="{ 'active': feedbackForm.resolved === true }"
                                    @click="feedbackForm.resolved = true"
                                >
                                    Yes
                                </button>
                                <button
                                    class="yn-btn"
                                    :class="{ 'active': feedbackForm.resolved === false }"
                                    @click="feedbackForm.resolved = false"
                                >
                                    No
                                </button>
                            </div>
                        </div>

                        <!-- Additional Feedback Section -->
                        <div class="feedback-section">
                            <h4 class="section-title">Add Additional feedback</h4>
                            <textarea
                                v-model="feedbackForm.additionalFeedback"
                                class="feedback-textarea"
                                placeholder="Type your feedback here..."
                                maxlength="320"
                            ></textarea>
                            <div class="char-count">{{ feedbackForm.additionalFeedback.length }}/320</div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="feedback-actions">
                            <button class="btn-submit" @click="submitFeedback">Submit Feedback</button>
                            <button class="btn-skip" @click="skipFeedback">Skip</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Login Section -->
        <section v-if="isOpen && !hasChatProfile" class="section-6">
            <div class="chat-box-div">
                <div class="box-top-div">
                    <div class="chat-top-div"><img src="@/assets/images/PriMeds_LogoNEW_White.png" loading="lazy" sizes="56.015625px" srcset="@/assets/images/PriMeds_LogoNEW_White.png 500w, @/assets/images/PriMeds_LogoNEW_White.png 800w, @/assets/images/PriMeds_LogoNEW_White.png 1000w" alt="" class="image-406">
                        <a href="#" @click.prevent="toggleChat" class="link-block-56 w-inline-block"><img src="@/assets/images/icon_Close.svg" loading="lazy" alt="" class="image-407"></a>
                    </div>
                    <div class="chat-body-div">
                        <div class="chat-reco-div">
                            <div class="chat-body-top">
                                <div class="text-block-788">Welcome! 😊</div>
                                <div class="text-block-788" style="font-weight: 300; font-size: 16px;"><br />Enter your name and email to get started. This helps us notify you if we get disconnected.</div>
                            </div>
                            <div class="chat-div">
                                <div class="dialogue-div">
                                    <form @submit.prevent="registerUser">
                                        <div class="_2-input-div city-state">
                                            <input class="tf_textfield-2 half w-input" maxlength="256" v-model="userData.first_name" name="First-Name-2" data-name="First Name 2" placeholder="First Name" type="text" id="First-Name-2" required>
                                            <input class="tf_textfield-2 half w-input" maxlength="256" v-model="userData.last_name" name="Last-Name-2" data-name="Last Name 2" placeholder="Last Name" type="text" id="Last-Name-2" required>
                                        </div>
                                        <input class="tf_textfield-2 w-input" maxlength="256" name="Email-Address-2" v-model="userData.email" data-name="Email Address 2" placeholder="Email Address" type="email" id="Email-Address-2" required>
                                        <div v-if="!submitted"> <input type="submit" class="checkout-button-2 w-button" style="color:#fff;" value="Get Started"> </div>
                                        <div v-else>
                                            <a href="#" class="checkout-button-2 w-button">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                                    </circle>
                                                </svg>
                                            </a>
                                        </div>
                                        <div class="text-block-865">By hitting submit you agree to receive reminder emails for chats, upcoming orders, tips, and other emails from {{ appName }}</div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </transition>

    <div class="chat-bubble" v-if="!isOpen && checkIcon" @click="toggleChat">
        <img v-if="!isOpen" src="@/assets/images/image.png" alt="Chat" class="chat-bubble-icon">
        <img v-else src="@/assets/images/icon_Close.svg" alt="Close" class="chat-bubble-icon">
    </div>
</div>
</template>

    
    
<script>
import {
    mapGetters
} from 'vuex';
import {
    io
} from 'socket.io-client';
import {
    format
} from 'date-fns';

export default {
    name: 'ChatWindow',
    props: ["hideIconOn"],

    data() {
        return {
            appName: "PriorityMeds",
            isOpen: false,
            pageOpenedOn: '',
            sessionId: null,
            conversationId: null,
            userId: 'anonymous',
            socket: null,
            messages: [],
            currentMessage: '',
            connectionStatus: 'disconnected',
            loginUrl: process.env.VUE_APP_API_ENDPOINT,
            email: null,
            password: null,
            submitted: false,
            err: false,
            errmsg: "",
            userInitialized: false,
            initializationAttempts: 0,
            maxInitializationAttempts: 3,
            reconnectTimer: null,
            isReconnecting: false,
            socketInitialized: false,
            pendingInitialization: false,
            userData: {
                first_name: '',
                last_name: '',
                email: '',
                source_web: 2,
                user_type: 'chat'
            },
            showFeedbackOverlay: false,
            feedbackForm: {
                rating: null,
                issues: [],
                resolved: null,
                additionalFeedback: ''
            },
            nextCursor: null,
            hasMoreHistory: true,
            isLoadingHistory: false,
            attachments: []
        }
    },

    computed: {
        ...mapGetters(['user']),

        userDetails() {
            if (this.isLoggedin && this.user) {
                return {
                    id: this.user.id,
                    name: `${this.user.first_name} ${this.user.last_name}`.trim(),
                    email: this.user.email
                };
            } else if (this.$store.getters.hasChatProfile) {
                const chatProfile = this.$store.getters.chatProfile;
                return {
                    id: chatProfile.id || `chat_${Date.now()}`,
                    name: `${chatProfile.first_name} ${chatProfile.last_name}`.trim(),
                    email: chatProfile.email
                };
            }
            return null;
        },

        hasChatProfile() {
            return this.isLoggedin || this.$store.getters.hasChatProfile;
        },

        isLoggedin() {
            return this.$store.getters.isAuthenticated;
        },

        socketUrl() {
            return process.env.VUE_APP_WS_URL || 'http://localhost:3000';
        },

        canSendMessage() {
            return this.socket?.connected &&
                (this.currentMessage.trim().length > 0 || this.attachments.length > 0) &&
                !this.isReconnecting;
        },

        checkIcon() {
                // Show icon only on HomePage and not when talkToDoc tab is active
                if (this.$route.name !== 'HomePage') {
                    return false;
                }
                console.log(this.$parent.currentTab)
                // Check if we're on HomePage but in the talkToDoc tab
                // You can access the parent component's currentTab through $parent
                if (this.$store.getters.activeHomeTab === 'doctor') {
                    return false;
                }

                return true;
            },

        issueOptions() {
            return [
                'Took too long',
                'Unhelpful resolution',
                'Lack of expertise',
                'Unfriendly tone',
                'Technical issues',
                'Other'
            ];
        },

        ratingLabel() {
            const labels = {
                1: 'Very Sad',
                2: 'Sad',
                3: 'Happy',
                4: 'Very Happy'
            };
            return this.feedbackForm.rating ? labels[this.feedbackForm.rating] : '';
        },

        shouldShowIssuesSection() {
            // Only show if rating is 1-2 (not 3-4 and not null)
            return this.feedbackForm.rating !== null && this.feedbackForm.rating < 3;
        }
    },

    watch: {
        userDetails: {
            immediate: true,
            handler(newDetails) {
                if (newDetails && !this.socketInitialized) {
                    this.initializeSocket();
                }
            }
        },

        isLoggedin(newValue) {
            console.log('👤 isLoggedin watcher triggered:', newValue, 'current userId:', this.userId);
            if (newValue) {
                this.initializeSocket();
            }
        }
    },

    created() {
        if (window.Tracker) {
            this.initializeFromTracker();
        }
        window.addEventListener('sessionInit', this.handleSessionInit);
        window.addEventListener('userIdentified', this.handleUserIdentified);
        this.$root.$on('toggle-chat', this.toggleChat);
    },
    mounted() {
        if (this.isLoggedin) {
            this.initializeFromTracker();
        }
    },
    beforeDestroy() {
        this.cleanup();
    },

    methods: {
        getRatingIcon(rating, isSelected) {
            try {
                const iconMap = {
                    1: { unselected: 'icon_rating_verysad1.webp', selected: 'icon_rating_verysad2.webp' },
                    2: { unselected: 'icon_rating_sad1.webp', selected: 'icon_rating_sad2.webp' },
                    3: { unselected: 'icon_rating_happy1.webp', selected: 'icon_rating_happy2.webp' },
                    4: { unselected: 'icon_rating_veryhappy1.webp', selected: 'icon_rating_veryhappy2.webp' }
                };

                const icon = iconMap[rating];
                const iconName = isSelected ? icon.selected : icon.unselected;

                // Use direct path for static assets
                return require(`@/assets/rating_icon/${iconName}`);
            } catch (error) {
                console.error('Error loading icon:', error);
                return '';
            }
        },

        async registerUser() {
            try {
                this.submitted = true;
                const response = await this.$axios.post(`${this.loginUrl}/api/chat-user`, this.userData);
                if (response.data.status === 'success') {
                    await this.$store.dispatch("setChatProfile", response.data.user);
                    this.initializeSocket();
                    this.$nextTick(() => {
                        if (this.socket?.connected) {
                            this.initializeUserDetails();
                        } else {
                            console.log('Socket not yet connected after registration');
                        }
                    });
                } else if (response.data.status === 'error' && response.data.message === 'Existing user found.') {
                    this.$router.push({
                        name: 'LoginPage',
                        query: {
                            "page_ref": "Checkouts"
                        }
                    });
                }
                this.submitted = false;
            } catch (error) {
                console.error('Error during registration:', error);
                this.errorMessage = 'An error occurred while creating chat profile.';
                this.submitted = false;
            }
        },
        async handleFileChange(event) {
            const files = event.target.files;
            if (!files || files.length === 0) return;

            const maxSize = 10 * 1024 * 1024; // 10MB
            const maxFiles = 5;

            console.log('📎 Files selected:', files.length);

            try {
                const newAttachments = [];
                const totalFiles = files.length + this.attachments.length;

                if (totalFiles > maxFiles) {
                    alert(`You can only upload a maximum of ${maxFiles} files`);
                    return;
                }

                for (let i = 0; i < files.length; i++) {
                    let file = files[i];
                    console.log(`📄 Processing file: ${file.name} (${file.type}, ${Math.round(file.size / 1024)}KB)`);

                    if (file.size > maxSize) {
                        alert(`File "${file.name}" exceeds the maximum size of 10MB`);
                        continue;
                    }

                    // Compress images before encoding
                    let processedFile = file;
                    let actualSize = file.size;

                    if (file.type.startsWith('image/')) {
                        try {
                            const compressedBlob = await this.compressImage(file);
                            processedFile = new File([compressedBlob], file.name, { type: file.type });
                            actualSize = processedFile.size;

                            // If compressed file is still too large, try with lower quality
                            if (actualSize > 3 * 1024 * 1024) { // 3MB
                                console.log('🗜️ File still large, compressing more...');
                                const moreCompressedBlob = await this.compressImage(file, 1280, 720, 0.6);
                                processedFile = new File([moreCompressedBlob], file.name, { type: file.type });
                                actualSize = processedFile.size;
                            }
                        } catch (err) {
                            console.warn('⚠️ Image compression failed, using original:', err);
                            processedFile = file;
                        }
                    }

                    const base64Content = await this.readFileAsBase64(processedFile);

                    const attachment = {
                        id: `temp-${Date.now()}-${i}`,
                        filename: file.name,
                        contentType: file.type,
                        size: actualSize,
                        content: base64Content,
                        encoding: 'base64'
                    };

                    newAttachments.push(attachment);
                    console.log('✅ File processed:', {
                        filename: attachment.filename,
                        originalSize: `${Math.round(file.size / 1024)}KB`,
                        processedSize: `${Math.round(actualSize / 1024)}KB`,
                        contentType: attachment.contentType,
                        base64Length: base64Content.length
                    });
                }

                this.attachments = [...this.attachments, ...newAttachments];
                console.log('📎 Total attachments ready:', this.attachments.length);
            } catch (err) {
                console.error('❌ Error processing files:', err);
                alert('Error processing files. Please try again.');
            } finally {
                // Reset the file input
                event.target.value = '';
            }
        },

        async compressImage(file, maxWidth = 1920, maxHeight = 1080, quality = 0.8) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        let width = img.width;
                        let height = img.height;

                        // Calculate new dimensions while maintaining aspect ratio
                        if (width > maxWidth || height > maxHeight) {
                            const ratio = Math.min(maxWidth / width, maxHeight / height);
                            width = width * ratio;
                            height = height * ratio;
                        }

                        canvas.width = width;
                        canvas.height = height;

                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);

                        // Convert to blob
                        canvas.toBlob(
                            (blob) => {
                                if (blob) {
                                    console.log(`🗜️ Image compressed: ${Math.round(file.size / 1024)}KB → ${Math.round(blob.size / 1024)}KB`);
                                    resolve(blob);
                                } else {
                                    reject(new Error('Canvas to Blob conversion failed'));
                                }
                            },
                            file.type || 'image/jpeg',
                            quality
                        );
                    };
                    img.onerror = reject;
                    img.src = e.target.result;
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        readFileAsBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const result = reader.result;
                    const base64Content = result.split(',')[1] || result;
                    resolve(base64Content);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        handleRemoveAttachment(id) {
            this.attachments = this.attachments.filter(attachment => attachment.id !== id);
        },

        downloadAttachment(attachment) {
            try {
                console.log('📥 Downloading attachment:', attachment.filename);

                // Convert base64 to blob
                const byteCharacters = atob(attachment.content);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: attachment.contentType });

                // Create download link
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = attachment.filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                console.log('✅ Download initiated:', attachment.filename);
            } catch (error) {
                console.error('❌ Error downloading attachment:', error);
                alert('Failed to download file. Please try again.');
            }
        },

        formatTimestamp(timestamp) {
            if (!timestamp) return '';
            return format(new Date(timestamp), 'HH:mm');
        },

        cleanup() {
            window.removeEventListener('sessionInit', this.handleSessionInit);
            window.removeEventListener('userIdentified', this.handleUserIdentified);
            this.cleanupSocket();
            if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
            }
        },
        initializeFromTracker() {
            if (!this.sessionId) {
                this.sessionId = window.Tracker?.getSessionId() || `session_${Date.now()}`;
            }
            if (this.isLoggedin && this.user?.id) {
                this.userId = this.user.id;
                this.initializeSocket();
            }
        },

        initializeSocket() {
            if (this.socket) {
                this.cleanupSocket();
            }
            const userDetails = this.userDetails;
            if (!userDetails) {
                console.warn('⚠️ initializeSocket called but userDetails is null');
                return;
            }
            try {
                // Update userId to match the current user
                this.userId = userDetails.id || 'anonymous';

                console.log('🔌 Initializing socket with userId:', this.userId, {
                    isLoggedin: this.isLoggedin,
                    userDetailsId: userDetails.id,
                    sessionId: this.sessionId
                });

                const socketConfig = {
                    transports: ['websocket'],
                    query: {
                        sessionId: this.sessionId || `session_${Date.now()}`,
                        userId: this.userId,
                        page: window.location.href
                    },
                    reconnection: true,
                    reconnectionAttempts: 5,
                    reconnectionDelay: 1000,
                    reconnectionDelayMax: 5000,
                    timeout: 10000
                };
                this.socket = io(this.socketUrl, socketConfig);
                this.socketInitialized = true;
                this.setupSocketListeners();
            } catch (error) {
                console.error('❌ Socket initialization error:', error);
                this.socketInitialized = false;
            }
        },

        setupSocketListeners() {
            this.socket.on('connect', this.handleConnect);
            this.socket.on('disconnect', this.handleDisconnect);
            this.socket.on('error', this.handleError);
            this.socket.on('connect_error', (error) => {
                console.error('❌ Connection error:', error);
                console.error('❌ Connection error stringified:', JSON.stringify(error, null, 2));
            });
            this.socket.on('chat_message', this.handleChatMessage);
            this.socket.on('history', this.handleHistory);
            this.socket.on('history_more', this.handleHistoryMore);
            this.socket.on('reconnect_attempt', this.handleReconnectAttempt);
            this.socket.on('reconnect_failed', this.handleReconnectFailed);
            this.socket.on('conversation_closed_ok', this.handleConversationClosedOk);

            // Catch any error events from the server
            this.socket.onAny((eventName, ...args) => {
                if (eventName.includes('error') || eventName.includes('invalid')) {
                    console.error(`❌ Socket event '${eventName}':`, args);
                    console.error('❌ Event data stringified:', JSON.stringify(args, null, 2));
                }
            });
        },

        handleConnect() {
            this.connectionStatus = 'connected';
            this.isReconnecting = false;
            if (this.userDetails) {
                this.initializeUserDetails();
            } else {
                console.log('No user details available yet');
            }

            if (this.isOpen) {
                this.loadChatHistory();
            }
        },

        handleDisconnect() {

            this.connectionStatus = 'disconnected';
            this.startReconnectTimer();
        },

        handleError(error) {
            console.error('❌ Socket.IO error:', error);
            console.error('❌ Socket error stringified:', JSON.stringify(error, null, 2));
            this.connectionStatus = 'error';
            if (error.message === 'User not initialized' &&
                this.initializationAttempts < this.maxInitializationAttempts) {
                this.retryInitialization();
            }
        },

        handleChatMessage(message) {
            console.log('📥 Received chat message:', message);
            console.log('📎 Message has attachments:', !!message.attachments);
            if (message.attachments) {
                console.log('📎 Attachments received:', message.attachments.map(a => ({
                    filename: a.filename,
                    type: a.contentType,
                    size: a.size,
                    hasContent: !!a.content
                })));
            }

            this.messages.push({
                role: 'assistant',
                content: message.content,
                timestamp: new Date(message.timestamp),
                attachments: message.attachments || []
            });
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },

        handleHistory(history) {
            console.log('📜 Loading chat history:', history);

            // Process messages with attachments
            const processedMessages = (history.content || [])
                .filter(msg => msg.role !== 'system')
                .map(msg => ({
                    ...msg,
                    attachments: msg.attachments || [],
                    timestamp: new Date(msg.timestamp)
                }));

            const messagesWithAttachments = processedMessages.filter(m => m.attachments && m.attachments.length > 0);
            if (messagesWithAttachments.length > 0) {
                console.log(`📎 Found ${messagesWithAttachments.length} messages with attachments in history`);
                messagesWithAttachments.forEach(msg => {
                    console.log(`  - ${msg.role} message with ${msg.attachments.length} attachments:`,
                        msg.attachments.map(a => ({ filename: a.filename, type: a.contentType, hasContent: !!a.content }))
                    );
                });
            }

            this.messages = processedMessages;

            // Store conversationId from backend
            if (history.conversationId) {
                this.conversationId = history.conversationId;
                console.log('Conversation ID stored:', this.conversationId);
            }

            // Handle pagination info
            this.hasMoreHistory = Boolean(history.hasMore);
            this.nextCursor = history.nextCursor || null;

            this.isLoadingHistory = false;
            this.$nextTick(() => this.scrollToBottom());
        },

        handleHistoryMore(payload) {
            // Get scroll container element
            const container = this.$refs.chatContainer;
            const prevScrollHeight = container?.scrollHeight || 0;

            // Process older messages with attachments
            const olderMessages = (payload.content || [])
                .filter(msg => msg.role !== 'system')
                .map(msg => ({
                    ...msg,
                    attachments: msg.attachments || [],
                    timestamp: new Date(msg.timestamp)
                }));

            // Prepend older messages to the beginning
            this.messages = [...olderMessages, ...this.messages];

            // Update pagination info
            this.hasMoreHistory = Boolean(payload.hasMore);
            this.nextCursor = payload.nextCursor || null;

            this.isLoadingHistory = false;

            // Restore scroll position after messages are prepended
            this.$nextTick(() => {
                if (container) {
                    const newScrollHeight = container.scrollHeight;
                    container.scrollTop = newScrollHeight - prevScrollHeight;
                }
            });
        },

        handleReconnectAttempt(attemptNumber) {
            console.log(attemptNumber)
            this.isReconnecting = true;
        },

        handleReconnectFailed() {

            this.isReconnecting = false;
            this.connectionStatus = 'error';
        },

        handleConversationClosedOk(data) {
            console.log('✓ Conversation closed successfully:', data);
            // Clear the conversationId since conversation is closed
            this.conversationId = null;
            // You can add additional handling here if needed
            // For example, clear messages or show a thank you message
        },

        startReconnectTimer() {
            if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
            }
            this.reconnectTimer = setTimeout(() => {
                if (this.isLoggedin || this.$store.getters.hasChatProfile) {
                    this.initializeSocket();
                }
            }, 5000);
        },

        retryInitialization() {
            setTimeout(() => {
                this.initializeUserDetails();
            }, 1000 * (this.initializationAttempts + 1));
            this.initializationAttempts++;
        },

        cleanupSocket() {
            if (this.socket) {
                this.socket.offAny();
                this.socket.disconnect();
                this.socket = null;
                this.socketInitialized = false;
            }
        },

        handleSessionInit(event) {
            const {
                sessionId,
                userId
            } = event.detail;
            this.sessionId = sessionId;
            this.userId = userId;
            this.initializeSocket();
        },

        handleUserIdentified(event) {
            const {
                newUserId
            } = event.detail;
            this.userId = newUserId;
            this.initializeSocket();
        },

        initializeUserDetails() {
            try {
                if (!this.socket?.connected) {
                    this.pendingInitialization = true;
                    return;
                }
                const userData = this.userDetails;
                if (!userData) {
                    return;
                }

                if (!userData.email) {
                    console.error('Invalid user data:', userData);
                    return;
                }
                this.socket.emit('init_user', userData);
                this.userInitialized = true;
                this.initializationAttempts = 0;
                this.pendingInitialization = false;
                this.setOnlineStatus();

            } catch (error) {
                console.error('Error initializing user details:', error);
                this.pendingInitialization = true;
            }
        },
        setOnlineStatus() {
            setInterval(() => {
                try {
                    if (this.socket && this.socket.connected && this.userDetails) {
                        // Client-side socket.emit doesn't use .to() - that's server-side only
                        this.socket.emit('user_online', {
                            userId: this.userDetails.id,
                            userName: this.userDetails.name,
                            userEmail: this.userDetails.email,
                            timestamp: new Date()
                        });
                    }
                } catch (error) {
                    console.error('Error sending online status:', error);
                }
            }, 2 * 60 * 1000); // 2 minutes interval
        },
        autoExpand() {
            const textarea = this.$refs.messageInput;
            if (textarea) {
                textarea.style.height = 'auto';
                textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
            }
        },

        async sendMessage() {
            if (!this.canSendMessage) return;

            try {
                const userMessage = {
                    role: 'user',
                    content: this.currentMessage.trim(),
                    timestamp: new Date(),
                    attachments: this.attachments.length > 0 ? [...this.attachments] : undefined
                };

                this.messages.push(userMessage);

                const socketPayload = {
                    userId: this.userId,
                    message: this.currentMessage.trim(),
                    attachments: this.attachments.length > 0 ? this.attachments : undefined
                };

                // Calculate total payload size
                const payloadString = JSON.stringify(socketPayload);
                const payloadSizeKB = Math.round(payloadString.length / 1024);
                const payloadSizeMB = (payloadSizeKB / 1024).toFixed(2);

                console.log('📤 Sending message via socket:', {
                    userId: socketPayload.userId,
                    messageLength: socketPayload.message.length,
                    hasAttachments: !!socketPayload.attachments,
                    attachmentCount: socketPayload.attachments?.length || 0,
                    payloadSize: `${payloadSizeKB}KB (${payloadSizeMB}MB)`,
                    attachmentDetails: socketPayload.attachments?.map(a => ({
                        filename: a.filename,
                        type: a.contentType,
                        originalSize: `${Math.round(a.size / 1024)}KB`,
                        base64Size: `${Math.round((a.content?.length || 0) / 1024)}KB`
                    }))
                });

                // Warn if payload is too large (typical Socket.IO limit is 1-10MB)
                if (payloadSizeKB > 5000) { // 5MB warning threshold
                    console.warn(`⚠️ Large payload detected: ${payloadSizeMB}MB - This may fail or be slow!`);
                    alert(`Warning: Large attachment detected (${payloadSizeMB}MB). This may fail to send. Consider using a smaller image.`);
                }

                // Log the full payload structure (without full base64 content for readability)
                const payloadForLogging = {
                    ...socketPayload,
                    attachments: socketPayload.attachments?.map(a => ({
                        ...a,
                        content: `[base64 ${a.content?.length || 0} chars]`
                    }))
                };
                console.log('📤 Full payload structure:', JSON.stringify(payloadForLogging, null, 2));

                // Emit with acknowledgment callback to catch server errors
                this.socket.emit('chat message', socketPayload, (response) => {
                    console.log('📨 Server acknowledgment:', response);
                    if (response?.error) {
                        console.error('❌ Server returned error:', JSON.stringify(response, null, 2));
                        alert(`Error: ${response.error}`);
                    } else {
                        console.log('✅ Server accepted message');
                    }
                });
                console.log('✅ Message emitted to socket');

                this.currentMessage = '';
                this.attachments = [];
                this.$nextTick(() => {
                    const textarea = this.$refs.messageInput;
                    if (textarea) {
                        textarea.style.height = 'auto';
                    }
                    this.scrollToBottom();
                });

            } catch (error) {
                console.error('❌ Error sending message:', error);
                console.error('❌ Error stringified:', JSON.stringify(error, null, 2));
                this.showError('Failed to send message. Please try again.');
            }
        },

        loadChatHistory() {
            try {
                if (this.socket?.connected) {
                    this.socket.emit('load_history', {});
                    this.isLoadingHistory = true;
                }
            } catch (error) {
                console.error('Error loading chat history:', error);
                this.isLoadingHistory = false;
            }
        },

        loadMoreHistory() {
            try {
                if (this.socket?.connected && this.hasMoreHistory && !this.isLoadingHistory && this.conversationId) {
                    this.isLoadingHistory = true;
                    this.socket.emit('load_more_history', {
                        conversationId: this.conversationId,
                        cursor: this.nextCursor,
                        limit: 25
                    });
                }
            } catch (error) {
                console.error('Error loading more history:', error);
                this.isLoadingHistory = false;
            }
        },

        handleScroll(event) {
            const container = event.target;
            // Check if user scrolled to the top
            if (container.scrollTop === 0 && this.hasMoreHistory && !this.isLoadingHistory) {
                this.loadMoreHistory();
            }
        },

        async getOrCreateConversation() {
            try {
                // Check if we have a stored conversationId from history
                if (this.conversationId) {
                    return { conversation: { id: this.conversationId } };
                }

                // If not loaded yet, trigger history load and wait
                if (this.socket?.connected) {
                    // Request history which will populate conversationId
                    this.loadChatHistory();

                    // Wait a bit for the history to load
                    await new Promise(resolve => setTimeout(resolve, 500));

                    if (this.conversationId) {
                        return { conversation: { id: this.conversationId } };
                    }
                }

                console.warn('No conversationId available yet');
                return { conversation: null };
            } catch (error) {
                console.error('Error getting conversation:', error);
                return { conversation: null };
            }
        },

        handleCloseChat() {
            // Show feedback overlay if user has messages
            if (this.messages.length > 0) {
                this.showFeedbackOverlay = true;
            } else {
                this.isOpen = false;
            }
        },

        toggleChat() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.pageOpenedOn = {
                    path: this.$route.path,
                    fullPath: this.$route.fullPath,
                    name: this.$route.name,
                    query: this.$route.query,
                    params: this.$route.params,
                    url: window.location.href,
                    openedAt: new Date().toISOString()
                };

                if (this.isLoggedin || this.$store.getters.hasChatProfile) {
                    if (!this.socket?.connected) {
                        this.initializeSocket();
                    }
                    this.loadChatHistory();
                    if (!this.userInitialized) {
                        this.initializeUserDetails();
                    }
                }
            }
        },

        toggleIssue(issue) {
            const index = this.feedbackForm.issues.indexOf(issue);
            if (index > -1) {
                this.feedbackForm.issues.splice(index, 1);
            } else {
                this.feedbackForm.issues.push(issue);
            }
        },

        async submitFeedback() {
            try {
                // Check if we have conversationId
                /*if (!this.conversationId) {
                    console.warn('No conversationId available, attempting to fetch...');
                    const { conversation } = await this.getOrCreateConversation();
                    if (!conversation?.id) {
                        console.error('Failed to get conversationId');
                        this.closeFeedback();
                        return;
                    }
                }*/

                const feedbackData = {
                    conversationId: this.conversationId,
                    rating: this.feedbackForm.rating,
                    feedback: this.feedbackForm.additionalFeedback || '',
                    wrong: this.feedbackForm.issues.join(', '),  // Convert array to comma-separated string
                    resolved: this.feedbackForm.resolved
                };

                console.log('Closing conversation with feedback:', feedbackData);

                // Send close_conversation event to socket
                try {
                    if (this.socket && this.socket.connected) {
                        this.socket.emit('close_conversation', feedbackData);
                    } else {
                        console.error('Socket not connected');
                    }
                } catch (socketError) {
                    console.error('Error emitting close_conversation:', socketError);
                }


                // Send feedback to your API as backup
                try {
                    let serverData = {
                        ...this.feedbackForm,
                        conversationId: this.conversationId,
                        userId: this.userDetails?.id,
                        sessionId: this.sessionId,
                        timestamp: new Date().toISOString()
                    };
                    console.log(JSON.stringify(serverData))
                    await this.$axios.post(`${this.loginUrl}/api/chat-feedback`, serverData);
                } catch (apiError) {
                    console.error('Error posting feedback to API:', apiError);
                }

                // Close overlay and chat
                this.closeFeedback();
            } catch (error) {
                console.error('Error submitting feedback:', error);
                // Still close the chat even if feedback submission fails
                this.closeFeedback();
            }
        },

        async skipFeedback() {
            try {
                // Check if we have conversationId
                if (!this.conversationId) {
                    console.warn('No conversationId available when skipping feedback');
                    const { conversation } = await this.getOrCreateConversation();
                    if (conversation?.id) {
                        this.conversationId = conversation.id;
                    }
                }

                // Send close_conversation event without feedback
                try {
                    if (this.socket && this.socket.connected && this.conversationId) {
                        console.log('Closing conversation without feedback, conversationId:', this.conversationId);
                        this.socket.emit('close_conversation', {
                            conversationId: this.conversationId,
                            rating: null,
                            feedback: '',
                            wrong: '',  // Empty string instead of empty array
                            resolved: null
                        });
                    } else {
                        console.error('Cannot close conversation - socket not connected or no conversationId');
                    }
                } catch (socketError) {
                    console.error('Error emitting close_conversation on skip:', socketError);
                }
            } catch (error) {
                console.error('Error closing conversation:', error);
            }

            this.closeFeedback();
        },

        closeFeedbackWithoutSubmit() {
            // Optional: You can choose to still close or do nothing when clicking outside
            // For now, let's not close to ensure user makes a conscious choice
        },

        closeFeedback() {
            this.showFeedbackOverlay = false;
            this.isOpen = false;
            // Reset feedback form
            this.feedbackForm = {
                rating: null,
                issues: [],
                resolved: null,
                additionalFeedback: ''
            };
        },

        scrollToBottom() {
            const chatContainer = this.$refs.chatContainer;
            if (chatContainer) {
                // Use setTimeout to ensure DOM has updated
                this.$nextTick(() => {
                    chatContainer.scrollTop = chatContainer.scrollHeight;
                });
            }
        },

        showError(message) {
            this.err = true;
            this.errmsg = message;
            setTimeout(() => {
                this.err = false;
                this.errmsg = '';
            }, 3000);
        },

        async onSubmit() {
            this.submitted = true;
            try {
                await this.$store.dispatch('login', {
                    email: this.email,
                    password: this.password
                });
                this.submitted = false;
                this.err = false;
            } catch (error) {
                this.submitted = false;
                this.err = true;
                this.errmsg = error.message || 'Login failed. Please try again.';
            }
        }
    }
};
</script>
    
    
<style scoped>

/* Chat container structure */
.section-6 {
    position: fixed;
    inset: 0%;
    z-index: 9999;
}

.chat-box-div {
    flex-flow: column;
    justify-content: space-between;
    width: 400px;
    display: flex;
    position: absolute;
    inset: 0% 0% 0% auto;
}


.chat-top-div {
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    display: flex;
}

.image-406 {
    height: 35px;
}

.image-407 {
    width: 25px;
}

.link-block-56 {
    width: 25px;
}

/* Chat messages area */
.chat-body-div {
    max-width: 400px;
    padding: 0 10px 0;
    position: relative;
    overflow: visible;
}

.chat-reco-div {
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    height: calc(100% - 120px);
    scroll-behavior: smooth;
}

.chat-reco-div::-webkit-scrollbar {
    display: none;
}

.chat-div {
    border: 1px #000;
    margin-bottom: 15px;
}

.dialogue-div {
    padding: 15px 10px 10px 0;
}

/* User message styling */
.user-div {
    flex-flow: row-reverse;
    width: 100%;
    margin-bottom: 25px;
    display: flex;
}

.speech {
    background-color: var(--f3-grey);
    border-radius: 20px;
    width: 75%;
    padding: 10px 15px;
}

.text-block-806 {
    font-family: var(--mulish);
    font-size: 17px;
    line-height: 21px;
}

/* Assistant message styling */
.platform-div {
    justify-content: flex-start;
    align-items: flex-start;
    display: flex;
}

.div-block-1757 {
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 99px;
    width: 25px;
    height: 25px;
    margin-right: 10px;
}

.response-div {
    width: 90%;
}

.paragraph-132 {
    font-family: var(--mulish);
    color: var(--black);
    width: auto;
    font-size: 17px;
    line-height: 21px;
}

/* Chat input area */
.box-bottom-div {
    position: sticky;
    bottom: 0;
    background: #fff;
    width: 100%;
    left: 0;
    right: 0;
    z-index: 100;
}

.chat-area-div {
    border-top: 1px solid #000;
    padding: 10px 10px 0;
}

.form-block-2 {
    margin-bottom: 0;
}

.form-10 {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 24px;
    background-color: #fff;
    transition: border-color 0.2s ease;
}

.form-10:focus-within {
    border-color: #999;
}

.text-field-53 {
    flex: 1;
    min-height: 24px;
    max-height: 120px;
    padding: 4px 12px 12px 12px;
    border: none;
    border-radius: 0;
    font-family: var(--mulish);
    font-size: 15px;
    line-height: 1.5;
    resize: none;
    overflow-y: auto;
    background-color: transparent;
}

.text-field-53:focus {
    outline: none;
}

.text-field-53::placeholder {
    color: #aaa;
}

.div-block-1754 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    transition: all 0.2s ease;
    background-color: transparent;
    height: 36px;
    width: 36px;
    align-self: flex-end;
    margin-top: 10px;
}


.div-block-1754:hover:not(.disabled) {
    background-color: rgba(0, 0, 0, 0.05);
}

.div-block-1754.disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.image-413 {
    width: 20px;
    height: 20px;
}

.chtnote {
    position: relative;
    text-align: center;
    width: 100%;
    font-size: 8px;
    line-height: 1rem;
    padding-bottom: 5px;
    clear: both;
}

/* Chat bubble when minimized */
.chat-bubble {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 60px;
    height: 60px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1000;
    transition: box-shadow 0.2s ease;
}

.chat-bubble:hover {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
}

.chat-bubble-icon {
    width: 28px;
    height: 28px;
}

/* Registration/login form elements */
.chat-body-top {
    margin-bottom: 15px;
    margin-top: 10px;
}

.text-block-788 {
    font-size: 21px;
    font-weight: 900;
}

._2-input-div {
    display: flex;
    justify-content: space-between;
}

.tf_textfield-2 {
    border-radius: 6px;
    margin-bottom: 25px;
}

.tf_textfield-2:focus {
    border-color: #6d22ff;
}

.tf_textfield-2::placeholder {
    font-size: 13px;
}

.tf_textfield-2.half {
    width: 48%;
}

.checkout-button-2 {
    font-weight: 700;
    width: 100%;
}

.text-block-865 {
    font-size: 12px;
    margin-top: 10px;
}

/* Loading History Indicator */
.loading-history {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 10px;
    gap: 10px;
}

.loading-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #2d6a4f;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-text {
    font-size: 13px;
    color: #666;
    font-family: var(--mulish);
}

/* Responsive adjustments */
@media screen and (max-width: 767px) {
    .div-block-1754 {
        margin-top: 1px;
    }
    .abubody {
        margin-bottom: 20vh;
        height: 80vh;
        position: fixed;
    }
    
    /* Enhance fixed positioning for mobile */
    .box-bottom-div {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        border-top: 1px solid #ccc;
    }
    
    .chat-reco-div {
        height: calc(100vh - 150px);
        padding-bottom: 80px;
    }
    
    .form-10 {
        display: flex;
        align-items: center;
    }
    
    .div-block-1754 {
        position: relative;
        transform: none;
        right: auto;
        top: auto;
        margin-left: 10px;
    }
}

@media (max-width: 479px) {
    .chat-box-div {
        flex-flow: column;
        justify-content: space-between;
        width: 100%;
        display: flex;
        inset: 0%;
    }
    
    .chat-body-div {
        max-width: 1000px;
        padding-top: 0;
        overflow: auto;
    }
    
    .chat-reco-div {
        height: calc(100vh - 170px);
    }
}

@media (min-width: 1024px) {
    .chat-box-div {
        margin-top: 20vh;
        height: 80vh;
        position: fixed;
    }

    .section-6 {
        margin-top: 75px;
    }

    .chat-reco-div {
        height: calc(80vh - 120px);
    }
}

/* Feedback Container Styles - Inside Chat Window */
.feedback-container {
    background: white;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.feedback-content {
    padding: 15px 20px;
    overflow-y: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.feedback-header {
    margin-bottom: 12px;
}

.feedback-title {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    margin: 0;
    color: #000;
    line-height: 1.3;
}

/* Rating Section */
.rating-section {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin: 12px 0 3px;
}

.rating-btn {
    width: 45px;
    height: 45px;
    border: none;
    border-radius: 8px;
    background-color: transparent;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #333;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.rating-btn:hover {
    transform: scale(1.1);
}

.rating-btn.active {
    transform: scale(1.15);
}

.rating-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.rating-label {
    text-align: center;
    font-size: 11px;
    color: #666;
    margin-bottom: 12px;
}

/* Feedback Section */
.feedback-section {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #e0e0e0;
}

.section-title {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 10px 0;
    text-align: center;
    color: #000;
}

/* Options Grid */
.options-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
}

.option-btn {
    padding: 8px 12px;
    border: 1.5px solid #d0d0d0;
    border-radius: 6px;
    background-color: white;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #000;
    font-weight: 500;
}

.option-btn:hover {
    border-color: #2e9bf0;
    background-color: #f8f8f8;
}

.option-btn.active {
    border-color: #2e9bf0;
    background-color: #2e9bf0;
    color: white;
}

/* Yes/No Buttons */
.yes-no-buttons {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.yn-btn {
    padding: 8px 30px;
    border: 1.5px solid #d0d0d0;
    border-radius: 6px;
    background-color: white;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #000;
}

.yn-btn:hover {
    border-color: #2e9bf0;
    background-color: #f8f8f8;
}

.yn-btn.active {
    border-color: #2e9bf0;
    background-color: #2e9bf0;
}

/* Textarea */
.feedback-textarea {
    width: 100%;
    min-height: 70px;
    max-height: 70px;
    padding: 10px;
    border: 1.5px solid #d0d0d0;
    border-radius: 6px;
    font-family: inherit;
    font-size: 12px;
    resize: none;
    margin-bottom: 3px;
}

.feedback-textarea:focus {
    outline: none;
    border-color: #2e9bf0;
}

.char-count {
    text-align: right;
    font-size: 10px;
    color: #999;
}

/* Action Buttons */
.feedback-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
}

.btn-submit {
    padding: 10px 20px;
    background-color: #2e9bf0;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.btn-submit:hover {
    background-color: #2e9bf0;
}

.btn-skip {
    padding: 6px 20px;
    background-color: transparent;
    color: #666;
    border: none;
    font-size: 12px;
    cursor: pointer;
    text-decoration: underline;
}

.btn-skip:hover {
    color: #333;
}

/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* Mobile Responsive */
@media (max-width: 479px) {
    .feedback-content {
        padding: 15px;
    }

    .rating-btn {
        width: 45px;
        height: 45px;
        font-size: 18px;
    }

    .options-grid {
        grid-template-columns: 1fr;
    }

    .feedback-title {
        font-size: 16px;
    }
}

/* File Attachment Styles */
.file-input-hidden {
    display: none;
}

.attachment-button {
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: all 0.2s ease;
    color: #666;
    flex-shrink: 0;
    background-color: transparent;
    border: none;
    height: 36px;
    width: 36px;
    align-self: flex-end;
    margin-bottom: 4px;
}

.attachment-button:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #000;
}

.attachment-button svg {
    width: 20px;
    height: 20px;
}

/* Attachments Preview (before sending) */
.attachments-preview {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin-bottom: 10px;
}

.attachment-preview-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 12px;
}

.attachment-icon {
    display: flex;
    align-items: center;
    color: #666;
}

.attachment-filename {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
}

.attachment-size {
    color: #999;
    font-size: 11px;
}

.attachment-remove {
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px;
    display: flex;
    align-items: center;
    color: #999;
    transition: color 0.2s ease;
}

.attachment-remove:hover {
    color: #e53e3e;
}

/* Message Attachments Display */
.message-attachments {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.message-attachment {
    display: inline-block;
}

.attachment-image-wrapper {
    position: relative;
    max-width: 200px;
    display: inline-block;
}

.attachment-image {
    max-width: 200px;
    border-radius: 8px;
    overflow: hidden;
}

.attachment-image img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 8px;
}

.image-download-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    border-radius: 4px;
    padding: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    opacity: 0;
}

.attachment-image-wrapper:hover .image-download-btn {
    opacity: 1;
}

.image-download-btn:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: scale(1.1);
}

.image-download-btn svg {
    color: white;
    stroke: white;
}

.attachment-file-info {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    font-size: 12px;
    max-width: 200px;
    transition: all 0.2s ease;
}

.attachment-file-info.clickable {
    cursor: pointer;
}

.attachment-file-info.clickable:hover {
    background-color: rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.attachment-file-info.assistant-attachment {
    background-color: rgba(0, 0, 0, 0.05);
}

.attachment-file-info.assistant-attachment.clickable:hover {
    background-color: rgba(0, 0, 0, 0.15);
}

.download-icon {
    margin-left: auto;
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

.attachment-file-info.clickable:hover .download-icon {
    opacity: 1;
}

.attachment-file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.attachment-file-size {
    color: rgba(0, 0, 0, 0.5);
    font-size: 11px;
}

.speech .attachment-file-info {
    background-color: rgba(0, 0, 0, 0.05);
}

.message-timestamp {
    display: block;
    margin-top: 5px;
    font-size: 11px;
    color: #999;
}

/* Responsive adjustments for attachments */
@media screen and (max-width: 767px) {
    .attachment-image,
    .attachment-image-wrapper {
        max-width: 150px;
    }

    .attachment-preview-item {
        font-size: 11px;
    }

    .attachment-filename {
        max-width: 100px;
    }

    /* Show download button on mobile without hover */
    .image-download-btn {
        opacity: 0.7;
    }

    .image-download-btn:active {
        opacity: 1;
    }
}

</style>
